import React, { useState, useEffect } from "react";
import { pdf } from "@react-pdf/renderer";
import { FaDownload } from "react-icons/fa";
import LoadingIcon from "../../../../../../../shared/resources/animated/LoadingIcon";

interface IProps {
  document: any;
  fileName: string;
}

const PdfDownloadLink = (props: IProps) => {
  const [pdfData, setPdfData] = useState<{
    loaded: boolean;
    url?: string;
    blob?: Blob;
  }>({ loaded: false });

  useEffect(() => {
    const renderPdf = async () => {
      const element = props.document;

      const blob = await pdf(element).toBlob();
      const url = URL.createObjectURL(blob);
      setPdfData({
        loaded: true,
        url,
        blob,
      });
    };
    renderPdf();
  }, [props.document]);

  if (pdfData.loaded) {
    return (
      <a href={pdfData.url} download={props.fileName}>
        <FaDownload className="download-icon" />
      </a>
    );
  } else {
    return <LoadingIcon className="download-icon" />;
  }
};

export default PdfDownloadLink;
